import {
  ISetupUserProfilePayload,
  IUserProfile,
  IUserProfileUpdatePayload,
} from '@interfaces/profile';

import { apiUrls } from './urls';
import { get, post, put } from './utils';

export const getUserProfile = () => get<IUserProfile>(apiUrls.userProfile.root);

export const updateUserProfile = (payload: IUserProfileUpdatePayload) =>
  put(apiUrls.userProfile.root, payload);

export const setupUserProfile = (payload: ISetupUserProfilePayload) =>
  post(apiUrls.userProfile.setup, payload);

export const loginCompleteUserProfile = () => post(apiUrls.userProfile.loginComplete);
